import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { ZoomableImage } from "@/components/ZoomableImage";

const INFOGRAPHIC = "https://customer-assets-39nsmqrw.emergentagent.net/job_nfc-pharmacy-connect/artifacts/pyc9ppqm_98A57364-3E55-4B33-874B-B295782A07CD.PNG";

const HowItWorks = () => {
  const { t } = useLang();
  return (
    <section id="how" className="relative overflow-hidden bg-muted/40 py-20 lg:py-28">
      <div className="mx-auto max-w-6xl px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-10 max-w-3xl">
          <h2 className="font-heading text-4xl font-bold tracking-tight text-primary lg:text-5xl">{t.how.title}</h2>
          <p className="mt-4 text-lg leading-relaxed text-muted-foreground">{t.how.intro}</p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="overflow-hidden rounded-3xl border border-border bg-white p-4 shadow-[0_40px_90px_-30px_rgba(10,37,64,0.35)] lg:p-8"
          data-testid="how-infographic">
          <ZoomableImage src={INFOGRAPHIC} alt={t.how.title} testId="how-infographic-img" className="w-full" />
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;
